import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { getRecommendedSkills } from '../../redux/actions/certificateVerification';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowRight } from '@fortawesome/free-solid-svg-icons';
import Slider from 'react-slick';
import { Mixpanel } from '../../config/Mixpanel';
import Constants from '../../common/constants';

const RecommendedCourses = ({handlerCertified}) => {

    const certificateData = useSelector((store)=> store?.certificateVerification?.certificateData);
     const isCertified =
    certificateData?.certificate_type === "certified" ? true : false;
    const dispatch = useDispatch();
    const [skills,setSkills] = useState([]);
 const variant = useSelector((store)=> store?.certificateVerification?.userType);
 const userDetails = useSelector((store) => store?.certificateVerification?.userInfo);

const settings = {
    dots: false,
    slidesToShow: 3,
    rows: 1,
    speed: 2000,
    autoplay: false,
    autoplaySpeed: 2000,
    easing: "linear",
    cssEase: "linear",
    infinite: false,
    arrows: false,
    responsive: [
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 4,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1.4,
          infinite: false,
          dots: false,
          arrows: false,
          swipeToSlide: true,
        },
      },
    ],
  };


    useEffect(()=>{
        if(certificateData?.certificate_name){
        dispatch(getRecommendedSkills(certificateData?.certificate_name , 5 , (successObj)=>{
            setSkills(successObj?.similar_list);

        } , (errorObj)=>{}))
        }

    },[certificateData?.certificate_name, dispatch])


 return (
  skills && <div className='w-full flex items-center gap-3'>
    <div className='text-[12px] text-white leading-[140%] w-[30%] md:text-[14px]'>Recommended For You:</div>
    <div className='flex  flex-nowrap overflow-x-auto gap-2 scrollbar-hide' style={{scrollbarWidth: 'none', msOverflowStyle: 'none'}}>
      {
        skills?.map((item, index) => 
          <div key={index} className='bg-[#1a3b65] whitespace-nowrap text-[14px] text-[#70AEFF] rounded-2xl py-1 md:py-2 px-3 flex-shrink-0 cursor-pointer md:text-[16px]' onClick={(e)=> {
            
            if(variant === "owner"){
              Mixpanel.track(Constants.Mixpanel.CERTIFICATE_VERIFICATION_OWNER_PAGE_RECOMMENDED_SKILLS_PILL_CLICKED)
            }
            else if(variant === "recruiter"){
              Mixpanel.track(Constants.Mixpanel.CERTIFICATE_VERIFICATION_RECRUITER_PAGE_RECOMMENDED_SKILLS_PILL_CLICKED)
            }else{
              Mixpanel.track(Constants.Mixpanel.CERTIFICATE_VERIFICATION_NORMAL_PAGE_RECOMMENDED_SKILLS_PILL_CLICKED)
            }


            handlerCertified({utm_source : 'certificate-verification' , utm_medium : 'recommended-courses' , is_landing: true , skill_name : item }) }}>
            {item} <FontAwesomeIcon icon={faArrowRight} size="md" className='ml-[6px]'/>
          </div>
        )
      }
    </div>
  </div>
)
}

export default RecommendedCourses
